import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { AppService } from "src/app/core/services/app.service";
import { ReportService } from "src/app/core/services/report.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CommandCenterReport } from "src/app/shared/models/CommandCenterReportConfiguration.item";
import { CheckItemRecord } from "src/app/shared/models/focusDataModels/CheckItemRecord";

@Component({
	selector: "app-product-bubble-chart",
	templateUrl: "./product-bubble-chart.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ProductBubbleChartComponent implements OnInit {
	@Input() report: CommandCenterReport;
	@Output() reportChange = new EventEmitter<CommandCenterReport>();

	chartConfig = {
		type: "bubble",
		data: undefined,
		options: {
			scales: {
				y: {
					title: {
						text: "Total Sales",
						display: true,
					},
					ticks: {
						// Include a dollar sign in the ticks
						callback: function (value, index, ticks) {
							return "$" + value;
						},
					},
				},
				x: {
					title: {
						text: "Food Cost",
						display: true,
					},
					ticks: {
						// Include a dollar sign in the ticks
						callback: function (value, index, ticks) {
							return "$" + value;
						},
					},
				},
			},
			plugins: {
				legend: {
					display: false,
				},
			},
		},
		plugins: [ChartDataLabels],
	};

	startDate: any;
	endDate: any;

	constructor(public app: AppService, public reportService: ReportService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.reportService.checkItems.subscribe((data) => {
			if (data.length > 0) {
				this.buildChartData(data);
			}
		});
	}

	async onDateChange() {
		await this.reportService.itemDataGetAll(this.app.moment(this.startDate).format("MMDDYYYY"), this.app.moment(this.endDate).format("MMDDYYYY"));
	}

	buildChartData(checkData: CheckItemRecord[]) {
		const data = this.flattenItemData(checkData);

		this.chartConfig.data = {
			datasets: data
				.filter((i) => i.Extension > 0 && i.MenuItem?.Cost > 0)
				.map((i, idx) => {
					const color = this.app.references.randomStrokeFillGenerator();
					return {
						label: [i.MenuItem.MenuName],
						backgroundColor: color.fill,
						borderColor: color.stroke,
						title: i.MenuItem.MenuName,
						data: [
							{
								x: i.MenuItem.Cost,
								y: i.Extension,
								r: i.Qty,
							},
						],
					};
				}),
		};
	}

	flattenItemData(data: CheckItemRecord[]) {
		const checkItems: CheckItemRecord[] = [];
		data.filter((i) => i.MenuItem?.Cost).forEach((cir) => {
			const itm = checkItems.find((itm) => itm.RecordNumber === cir.RecordNumber);
			if (!itm) {
				cir.RecordNumber = +cir.RecordNumber;
				cir.Qty = cir.Qty ? +cir.Qty : 1;
				cir.Extension = +cir.Extension || +cir.Price;
				checkItems.push(cir);
			} else {
				itm.Qty += +cir.Qty || 1;
				itm.Extension += +cir.Extension || +cir.Price;
			}
		});
		return checkItems;
	}
}
